module.exports = __webpack_public_path__ + "static/media/logged.af7a2cca.png";